import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { updateExplorerDisplayMode, updateFilterPanelVisibility } from '../../actions/DisplaySettingsActions';
import { addFieldToSortOrder } from '../../actions/spaces/AddFieldToSortOrderAction';
import { showContentTypes } from '../../actions/spaces/ContentExplorerFilterActions';
import {
  addToContentSelection,
  deselectAll,
  removeFromContentSelection,
  selectAll,
} from '../../actions/spaces/ContentExplorerSelectionActions';
import { addContentFavorite, removeContentFavorite } from '../../actions/spaces/FavoritesActions';
import { clearMixedContentFilters } from '../../actions/spaces/filters/FilterActions';
import { getContentDetail } from '../../actions/spaces/GetContentDetailAction';
import { requestSpaceContentsMissingSlice } from '../../actions/spaces/RequestSpaceContentsActions';
import { selectSortOrder } from '../../actions/spaces/SelectSortOrderAction';
import {
  selectCurrentlyApplicableContentTypes,
  selectMixedContentFilterClauses,
} from '../../selectors/ContentFilterSelectors';
import { selectContentFromAppState, selectSelectedContentItems, selectSpaceInfo } from '../../selectors/ContentSelectors';
import { selectDisplaySettings } from '../../selectors/DisplaySettingsSelectors';
import { SessionServerSelectors } from '../../selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { Explorer, ExplorerDispatchProps, ExplorerOwnProps, ExplorerStateProps } from './Explorer';

const mapStateToProps: MapStateToProps<ExplorerStateProps> = (state: AppState) => ({
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  isSelectionBusy: state.contentExplorer.selection.isBusy,
  items: selectContentFromAppState(state),
  explorerViewMode: selectDisplaySettings(state).explorerDisplayMode,
  selectedItems: selectSelectedContentItems(state),
  showFilterPanel: selectDisplaySettings(state).showFilterPanel,
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  spaceInfo: selectSpaceInfo(state),
  mixedContentFilterMap: selectMixedContentFilterClauses(state),
  contentSort: state.order,
  urls: siteUrlsSelector(state),
  displaySchedulesInClientTimezone: SessionServerSelectors.displaySchedulesInClientTimezone(state),
  ignoreExtractTaskPriority: SessionServerSelectors.ignoreExtractTaskPriority(state),
  catalogingOnSiteEnabled: state.session.info == null ? false : selectCatalogingOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<ExplorerDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
  selectItem: addToContentSelection,
  deselectItem: removeFromContentSelection,
  clearAllSelections: deselectAll,
  selectAll: selectAll,
  filterSelected: showContentTypes,
  changeExplorerViewMode: updateExplorerDisplayMode,
  updateFilterPanelVisibility: updateFilterPanelVisibility,
  contentSortSelected: selectSortOrder,
  requestSpaceContentsMissingSlice: requestSpaceContentsMissingSlice,
  addFieldToSortOrder: addFieldToSortOrder,
  clearMixedContentFilters: clearMixedContentFilters,
  getContentDetail: getContentDetail
}, dispatch);

export const ConnectedExplorer: React.ComponentClass<ExplorerOwnProps> =
    connect(mapStateToProps, mapDispatchToProps)(Explorer);
